import "leaflet/dist/leaflet.css"
import React, { useRef } from "react"
import { PageWrapper } from "../../components/PageWrapper"
import { ChevronDown } from "lucide-react"
import { useRegisterForm } from "./hooks/useRegisterForm"
import { HeroSection } from "./components/HeroSection"
import { RegistrationForm } from "./components/RegistrationForm"
import { HowItWorks } from "./components/HowItWorks"
import { FeatureSections } from "./components/FeatureSections"
import { CtaBanner } from "./components/CtaBanner"

const RegisterFarmer: React.FC = () => {
  const formRef = useRef<HTMLDivElement>(null)

  const scrollToForm = () =>
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "center" })

  const {
    form, submitted, loading,
    treeInput, setTreeInput, errors, regions, treeTypes,
    setField, addTree, removeTree, updateTree,
    handleSubmit, resetForm,
  } = useRegisterForm()

  return (
    <PageWrapper>
      {/* Hero */}
      <section className="relative min-h-screen bg-[#1a1a1a] overflow-hidden flex items-center">

        {/* Background */}
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=1600&q=80"
            alt="Farm landscape"
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#111]/80 via-[#111]/40 to-transparent" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#111] via-transparent to-[#111]/60" />
        </div>

        <div className="relative z-10 w-full max-w-[1200px] mx-auto px-6 lg:px-8 py-24 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Left */}
          <HeroSection onScrollToForm={scrollToForm} />

          {/* Right — Form with GPS modal */}
          <div ref={formRef}>
            <RegistrationForm
              form={form}
              submitted={submitted}
              loading={loading}
              treeInput={treeInput}
              onTreeInputChange={setTreeInput}
              onFieldChange={setField}
              onAddTree={addTree}
              onRemoveTree={removeTree}
              onUpdateTree={updateTree}
              onSubmit={handleSubmit}
              onReset={resetForm}
              errors={errors}
              regions={regions}
              treeTypes={treeTypes}
            />
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-neutral-600 text-[10px] tracking-widest uppercase">Scroll</span>
          <ChevronDown className="w-4 h-4 text-neutral-600" />
        </div>
      </section>

      <HowItWorks />
      <FeatureSections />
      <CtaBanner onScrollToForm={scrollToForm} />
    </PageWrapper>
  )
}

export default RegisterFarmer